export const VocabChronicCategories = {
    'cardiovascular_diseases' : ['Enfermedades cardiovasculares (ECV)', 'Cardiovascular Diseases (CVD)',],
    'respiratory_diseases' : ['Enfermedades respiratorias', 'Respiratory diseases',],
    'diabetes': ['Diabetes', 'Diabetes'],
    'kidney_diseases' : ['Enfermedades renales (ER)', 'Kidney diseases (CKD)',],
    'neurological_disorders' : ['Trastornos neurológicos', 'Neurological disorders',],
    'cancer': ['Cáncer', 'Cancer'],
    'musculoskeletal_disorders': ['Trastornos musculoesqueléticos', 'Musculoskeletal disorders'],
    'autoimmune_diseases': ['Enfermedades autoinmunes', 'Autoimmune diseases'],
    'metabolic_disorders': ['Trastornos metabólicos', 'Metabolic disorders'],
    'digestive_system_disorders': ['Trastornos del sistema digestivo', 'Digestive system disorders'],
    'mental_health_conditions': ['Trastornos de la salud mental', 'Mental health conditions'],
    'infectious_diseases': ['Enfermedades infecciosas', 'Infectious diseases'],
    'skin_conditions': ['Trastornos crónicos de la piel', 'Skin conditions'],
  }
    